var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9525 5.41501C18.3333 6.90001 18.3333 10 18.3333 10C18.3333 10 18.3333 13.1 17.9525 14.585C17.7408 15.4058 17.1217 16.0517 16.3375 16.27C14.9133 16.6667 9.99999 16.6667 9.99999 16.6667C9.99999 16.6667 5.08916 16.6667 3.66249 16.27C2.87499 16.0483 2.25666 15.4033 2.04749 14.585C1.66666 13.1 1.66666 10 1.66666 10C1.66666 10 1.66666 6.90001 2.04749 5.41501C2.25916 4.59418 2.87832 3.94834 3.66249 3.73001C5.08916 3.33334 9.99999 3.33334 9.99999 3.33334C9.99999 3.33334 14.9133 3.33334 16.3375 3.73001C17.125 3.95168 17.7433 4.59668 17.9525 5.41501V5.41501ZM8.33332 12.9167L13.3333 10L8.33332 7.08334V12.9167Z",
    fill: "#7D59C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c3b374e08e6732e2fa253ec4968af0aa.svg";
export { ForwardRef as ReactComponent };